import { render, staticRenderFns } from "./CurrentDiagnosisInfo.vue?vue&type=template&id=fcbc80be"
import script from "./CurrentDiagnosisInfo.vue?vue&type=script&lang=js"
export * from "./CurrentDiagnosisInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports